import script from "./PayrollSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./PayrollSidebar.vue?vue&type=script&setup=true&lang=js"

import "./PayrollSidebar.vue?vue&type=style&index=0&id=3a1834b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a1834b7"]])

export default __exports__